import React, { useState } from "react";
import api from "@/lib/api";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Select, SelectTrigger, SelectValue, SelectContent, SelectItem,
} from "@/components/ui/select";
import { toast } from "sonner";

export default function CreatePortalDialog({ clients = [], existing = null, onClose, onSaved }) {
  const [clientId, setClientId] = useState(existing?.client_id || clients[0]?.id || "");
  const [label, setLabel] = useState(existing?.label || "");
  const [url, setUrl] = useState(existing?.url || "");
  const [username, setUsername] = useState(existing?.username || "");
  const [password, setPassword] = useState(existing?.password || "");
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (!clientId || !label.trim() || !url.trim()) { toast.error("Client, label and URL are required"); return; }
    setLoading(true);
    try {
      const body = { client_id: clientId, label, url, username, password };
      if (existing) await api.patch(`/portals/${existing.id}`, body);
      else await api.post("/portals", body);
      toast.success(existing ? "Portal updated" : "Portal added");
      onSaved?.(); onClose();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Could not save portal");
    } finally { setLoading(false); }
  };

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="create-portal-dialog">
        <DialogHeader><DialogTitle className="font-display">{existing ? "Edit portal access" : "Add portal access"}</DialogTitle></DialogHeader>
        <div className="space-y-4 py-1">
          <div className="space-y-2">
            <Label>Client</Label>
            <Select value={clientId} onValueChange={setClientId}>
              <SelectTrigger data-testid="portal-client-select"><SelectValue placeholder="Select client" /></SelectTrigger>
              <SelectContent>{clients.map((c) => <SelectItem key={c.id} value={c.id}>{c.company || c.name}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <div className="space-y-2"><Label>Label</Label><Input value={label} onChange={(e) => setLabel(e.target.value)} placeholder="e.g. Pilot — Staging" data-testid="portal-label-input" /></div>
          <div className="space-y-2"><Label>Portal URL</Label><Input value={url} onChange={(e) => setUrl(e.target.value)} placeholder="https://…" data-testid="portal-url-input" /></div>
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2"><Label>Username</Label><Input value={username} onChange={(e) => setUsername(e.target.value)} data-testid="portal-username-input" /></div>
            <div className="space-y-2"><Label>Password</Label><Input value={password} onChange={(e) => setPassword(e.target.value)} data-testid="portal-password-input" /></div>
          </div>
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={onClose}>Cancel</Button>
          <Button onClick={submit} disabled={loading} className="bg-indigo-600 hover:bg-indigo-700" data-testid="portal-save-submit">
            {loading ? "Saving…" : existing ? "Save changes" : "Add portal"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
